import HTTP from "../http";
import Jsona from "jsona";
import subscriptionStates from "@/utils/states/subscription";

const dataFormatter = new Jsona();

export default {
  async index(page, sort) {
    try {
      let results = await HTTP.normal.get(
        `/subscriptions?include=cycles,professional.account&page[number]=${page}&sort=-starts_at`
      );

      results = {
        data: dataFormatter.deserialize(results.data),
        meta: results.data.meta
      };

      results.data = subscriptionStates.filterCycles(results.data);
      results.data = subscriptionStates.sortCycles(results.data);
      results.data = subscriptionStates.sortByState(results.data);

      return results;
    } catch (e) {
      throw "Ocorreu um erro ao listar as assinaturas!";
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/subscriptions.js